/* eslint-disable */
import libraries from '../arduino/libraries'

export default function init(Blockly, profile) {
  Blockly.Arduino.thinger = {};

  Blockly.Arduino.thinger_init_esp01 = function () {
      var a = Blockly.Arduino.quote_(this.getFieldValue("WIFINAME")),
          b = Blockly.Arduino.quote_(this.getFieldValue("WIFIPASS")),
          c = Blockly.Arduino.quote_(this.getFieldValue("THINGER_USER_ID")),
          d = Blockly.Arduino.quote_(this.getFieldValue("THINGER_DEVICE_ID")),
          e = Blockly.Arduino.quote_(this.getFieldValue("THINGER_AUTH"));

    Blockly.Arduino.definitions_.var_wifi_ssid || (
    Blockly.Arduino.definitions_.var_wifi_ssid =
      "const char wifi_ssid[] = " + a + ";"
      );
    Blockly.Arduino.definitions_.var_wifi_pass || (
    Blockly.Arduino.definitions_.var_wifi_pass =
      "const char wifi_pass[] = " + b + ";"
      );
    Blockly.Arduino.definitions_.var_thinger_host =
      'const char thinger_host[] = "backend.thinger.io";';
    Blockly.Arduino.definitions_.var_thinger_port =
      'const char thinger_port[] = "80";';
    Blockly.Arduino.definitions_.var_thinger_user_id =
      "const char thinger_user_id[] = " + c + ";";
    Blockly.Arduino.definitions_.var_thinger_device_id =
      "const char thinger_device_id[] = " + d + ";";
    Blockly.Arduino.definitions_.var_thinger_auth =
      "const char thinger_auth[] = " + e + ";";
    Blockly.Arduino.definitions_.definitions_esp01_serial || (
    Blockly.Arduino.definitions_.definitions_esp01_serial =
      "//ESP AT modem over Hardware Serial. You can't use Serial for debugging!!\n" +
      "#define esp8266 Serial "
      );

    Blockly.Arduino.definitions_fnc_["fnc_wifi_connect"] || (
      Blockly.Arduino.definitions_fnc_["fnc_wifi_connect"] =
      'uint8_t espWifiInit() {\n' +
      '  bool err = false;\n' +
      '\n' +
      '  esp8266.begin(115200);                                   // Start at modem\n' +
      '  err |= !sendCommand((char *)"AT", 5, (char *)"OK");      // Kick\n' +
      '  err |= !sendCommand((char *)"AT+RST", 5, (char *)"OK");  // Reset\n' +
      '  delay(4000);\n' +
      '\n' +
      '  err |= !sendCommand((char *)"AT+CWMODE=1", 5, (char *)"OK"); // Station mode\n' +
      '  err |= !sendCommand((char *)"AT+CWJAP=\\""                         +\n' +
      '                       String(wifi_ssid)                            +\n' +
      '                       (char *)"\\",\\""                              +\n' +
      '                       String(wifi_pass)                            +\n' +
      '                       (char *)"\\"", 22, (char *)"OK");        // Connect to WiFi\n' +
      '  err |= !sendCommand((char *)"AT+CIPMUX=0", 5, (char *)"OK"); // Single TCP connection\n' +
      '  return err;\n' +
      '}\n'
    );

    Blockly.Arduino.definitions_fnc_["fnc_send_at_command"] || (
      Blockly.Arduino.definitions_fnc_["fnc_send_at_command"] =
      'bool sendCommand(String command, int maxTry, char readReplay[]) {\n' +
      '  bool found = false;\n' +
      '  uint8_t countTry = 0;\n' +
      '  while (countTry < (maxTry * 1)) {\n' +
      '    esp8266.println(command);\n' +
      '    if (esp8266.find(readReplay)) {\n' +
      '      found = true;\n' +
      '      break;\n' +
      '    }\n' +
      '    countTry++;\n' +
      '  }\n' +
      '  return found;\n' +
      '}\n'
    );

    Blockly.Arduino.setups_.setup_esp_wifi || (
      Blockly.Arduino.setups_.setup_esp_wifi = "  while (espWifiInit());\n"
    );

    return "";
  };

  Blockly.Arduino.thinger_upload = function () {
    var code;
    var nItems = this.itemCount_;
    var elements = Array(this.itemCount_),
        names = Array(this.itemCount_);
    for (var i = 0; i < nItems; i++) {
      elements[i] = Blockly.Arduino.valueToCode(this, "ADD" + i, Blockly.Arduino.ORDER_NONE) || "0";
      names[i] = this.getFieldValue("NAME" + i) || "unamed" + i;
    }

    // list definition
    code = "\n#define V(x)  isnan(x)?0:x";
    Blockly.Arduino.definitions_["validation_number"] = code;

    // list definition
    code = "\nString " + "thingerData" + "[" +  nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "thingerData"] = code;
    // list length definition
    code = "int " + "thingerData" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "thingerData" + "_size"] = code;

    // list definition
    code = "\nString " + "thingerNames" + "[" +  nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "thingerNames"] = code;
    // list length definition
    code = "int " + "thingerNames" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "thingerNames" + "_size"] = code;

    Blockly.Arduino.definitions_fnc_["fnc_thinger_http_post"] =
      "uint8_t thingerHTTPPost( int numFields ,\n" +
      "                  String thingerData[],\n" +
      "                  String thingerNames[]) {\n" +
      "  uint8_t err = -1;\n" +
      "  // TCP conection\n" +
      '  if (sendCommand((char *)"AT+CIPSTART=\\"TCP\\",\\"" +\n' +
      '                   String(thinger_host) + (char *)"\\"," + \n' +
      '                   String(thinger_port), 15, (char *)"OK")) {\n' +
      "    // Local Strings\n" +
      '    String bodyData    = "";\n' +
      '    String endPoint    = "";\n' +
      '    String headerData  = "";\n' +
      '    // Payload as JSON\n' +
      '    for ( int fieldNumber = 0; fieldNumber < numFields; fieldNumber++ ) {\n' +
      '      bodyData += (fieldNumber==0)?"{\\"":",\\"";\n' +
      '      bodyData += thingerNames[fieldNumber] + "\\"" +\n' +
      '                  ":" +\n' +
      '                  thingerData[fieldNumber];\n' +
      '      bodyData += (fieldNumber==numFields-1)?"}":"";\n' +
      '    }\n' +
      '    // Endpoint\n' +
      '    endPoint = "/v3/users/"\n' +
      '               + String(thinger_user_id)\n' +
      '               + "/devices/"\n' +
      '               + String(thinger_device_id)\n' +
      '               + "/callback/data";\n' +
      '    // HTTP request\n' +
      '    headerData =  String(F("POST ")) + String(endPoint) + String(F(" HTTP/1.1\\r\\n"))\n' +
      '                + String(F("Host: backend.thinger.io\\r\\n"))\n' +
      '                + String(F("User-Agent: electrolab/1.0.1\\r\\n"))\n' +
      '                + String(F("Content-Type: application/json;charset=UTF-8\\r\\n"))\n' +
      '                + String(F("Connection: keep-alive\\r\\n"));\n' +
      '    headerData += String(F("Authorization: "));\n' +
      '    headerData += thinger_auth;\n' +
      '    headerData += String(F("\\r\\n"));\n' +
      '    headerData += String(F("Accept: application/json, text/plain, */*\\r\\n"));\n' +
      '    headerData += String(F("Content-Length: ")) + String(bodyData.length()) + String(F("\\r\\n"))\n' +
      '                + String(F("\\r\\n"));\n' +
      '    if (sendCommand((char *)"AT+CIPSEND=" + String(headerData.length()+bodyData.length()), 14, (char *)">")) {\n' +
      '      esp8266.print(headerData);\n' +
      '      esp8266.println(bodyData);\n' +
      '    }\n' +
      '    delay(1500);\n' +
      '    sendCommand((char *)"AT+CIPCLOSE", 10, (char *)"OK");\n' +
      '    err = 0;\n' +
      '  }\n' +
      '  return err;\n' +
      '}\n';
      code = "";
      for (var i = 0; i < nItems; i++) {
          code += 'thingerNames[' + i + '] = String("' + names[i] + '"); thingerData[' + i + '] = String(V(' + elements[i] + '));\n';
      }
      code += "thingerHTTPPost(" + nItems + ", thingerData, thingerNames);\n\n";
     // return code
     return code;
  };
}